import * as Popover from '@radix-ui/react-popover';
import dayjs from 'dayjs';
import { Megaphone } from '@velocity-exchange/icons';
import { cj, cm } from 'src/utils/classNames';
import { WithClassName } from 'src/utils/UtilityTypes';
import { DROPDOWN_SIDE_OFFSET } from 'src/components/primitives/DropdownUi/consts';
import DropdownUi from 'src/components/primitives/DropdownUi/DropdownUi';
import PresetTag from 'src/components/Tags/PresetTag';
import useFeatureAnnouncementTrigger from 'src/components/FeatureAnnouncementTrigger/hooks/useFeatureAnnouncementTrigger';
import MegaphoneWithDot from 'src/components/Icons/MegaphoneWithDot';
import FooterButton from 'src/components/Buttons/FooterButton';
import { STANDARD_DATE_FORMAT } from 'src/constants/dates';

export default function FeatureAnnouncementTrigger({
	className,
}: WithClassName) {
	const {
		popoverOpen,
		setPopoverOpen,
		announcements,
		unseenCount,
		hasSeenAnnouncement,
		showFeatureAnnouncementModal,
	} = useFeatureAnnouncementTrigger();

	const hasUnseenAnnouncements = unseenCount > 0;

	return (
		<Popover.Root open={popoverOpen} onOpenChange={setPopoverOpen} modal>
			<Popover.Trigger asChild>
				<FooterButton
					className={cm(
						'relative',
						hasUnseenAnnouncements && 'typo-label-xs text-text-default',
						className
					)}
				>
					{hasUnseenAnnouncements ? <MegaphoneWithDot /> : <Megaphone />}

					<span className="typo-body-xs whitespace-nowrap">
						What&apos;s New
						{hasUnseenAnnouncements && ` (${unseenCount})`}
					</span>
				</FooterButton>
			</Popover.Trigger>
			<Popover.Portal>
				<Popover.Content
					asChild
					align="start"
					sideOffset={DROPDOWN_SIDE_OFFSET}
				>
					<DropdownUi.Content className="max-w-70 min-w-60">
						<div className="flex flex-col">
							{announcements.map((announcement) => {
								const hasSeen = hasSeenAnnouncement(announcement);

								return (
									<button
										key={announcement.name}
										onClick={() => showFeatureAnnouncementModal(announcement)}
									>
										<DropdownUi.Item className="items-start justify-start gap-x-xs">
											{/* Unseen indicator dot. */}
											<span
												className={cj(
													'size-[5px] translate-y-full rounded-full bg-negative-red',
													hasSeen && 'invisible'
												)}
											/>

											<div className="flex flex-col gap-y-sm text-left">
												<span className="flex items-center gap-x-xs typo-label-xs text-text-default">
													{announcement.title}
													{announcement.isCurrent && <PresetTag preset="new" />}
												</span>

												<span className="typo-body-2xs text-text-secondary">
													{dayjs(announcement.addedDateTsMillis).format(
														STANDARD_DATE_FORMAT
													)}
												</span>
											</div>
										</DropdownUi.Item>
									</button>
								);
							})}
						</div>
					</DropdownUi.Content>
				</Popover.Content>
			</Popover.Portal>
		</Popover.Root>
	);
}
